import type { Capability } from '@home/shared';

/** Same semantics as shared/access.ts hasCapability, kept local to avoid bundling zod. */
const ORDER: Capability[] = ['view', 'control', 'configure'];
export function hasCapability(have: readonly Capability[] | undefined, need: Capability): boolean {
  if (!have) return false;
  if (need === 'history') return have.includes('history');
  const n = ORDER.indexOf(need);
  return have.some((c) => c !== 'history' && ORDER.indexOf(c) >= n);
}
